import { render, staticRenderFns } from "./UsuariosData.vue?vue&type=template&id=1b475382&"
import script from "./UsuariosData.vue?vue&type=script&lang=js&"
export * from "./UsuariosData.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosData.vue?vue&type=style&index=0&id=1b475382&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports